import React, { useState } from "react";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import "./PlyrPlayer.css"; // 自定义悬浮样式

export default function PlyrPlayer({ videoSrc, poster }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const source = {
    type: "video",
    sources: [
      {
        src: videoSrc,
        type: "video/mp4"
      }
    ],
    poster: poster
  };

  return (
    <>
      {/* 缩略视频模式 */}
      {!isExpanded && (
        <div className="plyr-thumbnail-container">
          <Plyr source={source} options={{ controls: ["play", "progress", "current-time", "fullscreen"] }} />
        </div>
      )}

      {/* 悬浮播放层 */}
      {isExpanded && (
        <div className="plyr-floating-overlay">
          <div className="plyr-floating-box">
            <Plyr source={source} autoPlay />
          </div>
        </div>
      )}
    </>
  );
}
